import { createFileRoute } from '@tanstack/react-router';

import { TeamsListMobilePage } from '@/pages/teams-list/teams-list-mobile-page';
import { TeamsListPage } from '@/pages/teams-list/teams-list-page';
import { useMobile } from '@/shared/lib/use-mobile';

function TeamsIndexRoute() {
  const isMobile = useMobile();
  return isMobile ? <TeamsListMobilePage /> : <TeamsListPage />;
}

export const Route = createFileRoute('/teams/')({ component: TeamsIndexRoute });
